<script lang="jsx">
import mixin from '@/plans/mx/shopping-cart';
import { mapGetters } from 'vuex';
import _ from 'lodash';

export default {
  mixins: [mixin],
  computed: {
    ...mapGetters(['getBoughtBasePlanInfo', 'getSelectedPlans']),
    oldCategory() {
      return _.get(this.getBoughtBasePlanInfo, 'plans.0.category', '');
    },
    newCategory() {
      return _.get(this.getSelectedPlans, '0.category', '');
    },
    categoryChangeCase() {
      return this.oldCategory && this.oldCategory !== this.newCategory;
    },
  },
  methods: {
    renderTitle(plan) {
      if (this.categoryChangeCase) {
        return this.mx_title(
          this.$t('billing.planform.title.zoom_meeting_zoomonenew'),
          undefined,
          plan?.plan_code,
          plan?.parent_category,
        );
      }
      // Order Confirmation email
      return this.mx_title(
        this.$t('billing.zone_basic_plus.title'),
        this.mx_price(plan),
        plan?.plan_code
      );
    },
    renderSubTitle(plan) {
      if (this.categoryChangeCase) {
        return this.mx_subTitle(
          this.$t('billing.plan1_to_plan2', {
            oldPlan: this.$t(`billing.${this.oldCategory}`),
            newPlan: this.$t('one.lite'),
          }),
          this.mx_price(plan),
          plan?.plan_code,
        );
      }
      return null;
    },
    $renderPrice() {
      return this.mx_plans.map((plan) => {
        return (
          <div class="opc-cart-item">
            {this.renderTitle(plan)}
            {this.renderSubTitle(plan)}
            {this.mx_discount(plan.plan_code)}
            {this.mx_cycle(plan.billing_cycle)}
            {this.mx_new_license(plan, plan.cartInfo.selected_number)}
          </div>
        );
      });
    },
  },
};
</script>
